export interface FAQItem {
  question: string;
  answer: string;
  category: string;
}

export const faqs: FAQItem[] = [
  {
    question: "凪光在线是什么？",
    answer: "凪光在线是一个值得信赖的在线服务平台，提供流畅稳定的在线体验。平台汇集了丰富的功能模块，包括实时数据处理、智能推荐、安全防护等，满足个人和企业用户多样化的在线服务需求。",
    category: "general",
  },
  {
    question: "如何注册凪光在线账号？",
    answer: "访问凪光在线官网，点击右上角「注册」按钮，输入手机号码获取验证码，设置密码后即可完成注册。注册过程简单快捷，通常只需2-3分钟。",
    category: "account",
  },
  {
    question: "凪光在线是否免费使用？",
    answer: "凪光在线提供基础版免费使用，涵盖大部分核心功能。同时提供高级版和企业版付费方案，解锁更多高级功能和更大使用额度。具体方案可查看官网定价页面。",
    category: "pricing",
  },
  {
    question: "如何在手机上使用凪光在线？",
    answer: "您可以通过手机浏览器访问凪光在线移动网页版，或下载官方APP。移动端与PC端数据实时同步，让您随时随地畅享服务。",
    category: "usage",
  },
  {
    question: "忘记了登录密码怎么办？",
    answer: "在登录页面点击「忘记密码」，输入注册时绑定的手机号或邮箱，系统会发送验证码。验证身份后即可设置新密码。如绑定信息已变更，请联系客服协助处理。",
    category: "account",
  },
  {
    question: "凪光在线如何保障用户数据安全？",
    answer: "我们采用AES-256数据加密、TLS 1.3传输加密、多重身份验证等技术手段，并严格遵循数据保护法规，全方位保障您的数据安全和隐私。详情可查阅隐私政策页面。",
    category: "security",
  },
  {
    question: "平台支持哪些浏览器？",
    answer: "凪光在线全面支持Chrome、Firefox、Safari、Edge等主流浏览器的最新两个大版本。为获得最佳体验，建议将浏览器更新至最新版本。",
    category: "technical",
  },
  {
    question: "如何联系凪光在线客服？",
    answer: "您可以通过以下方式联系我们：在线客服（官网右下角）、客服邮箱 support@phuucr.cn、客服热线 400-888-6666。客服工作时间为周一至周五 9:00-21:00，周末 10:00-18:00。",
    category: "support",
  },
  {
    question: "能否同时登录多个设备？",
    answer: "支持。您可以在PC、手机、平板等多个设备上同时登录同一个账号，所有设备间的数据将实时同步，不会产生冲突。",
    category: "usage",
  },
  {
    question: "凪光在线最新地址是什么？如何获取？",
    answer: "凪光在线的最新官方地址始终在本官网公布。建议收藏本页面或关注官方社交媒体账号，以便及时获取最新入口信息。请勿通过第三方不明链接访问平台。",
    category: "general",
  },
];